export default __webpack_public_path__ + "media/images/no-image.475f5fa0dfb528bb1c760dee53a3ed9c.webp";